<template>
  <div class="wrapper">
    <svg :height="radius * 2" :width="radius * 2">
      <circle
        stroke="#fff"
        fill="transparent"
        :stroke-dasharray="circumference + ' ' + circumference"
        :style="{ strokeDashoffset }"
        :stroke-width="stroke"
        :r="normalizedRadius"
        :cx="radius"
        :cy="radius"
      />
    </svg>
    <div class="slot">
      <slot>01</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressRing',
  props: {
    radius: {
      type: Number,
      default: 50
    },
    progress: Number,
    stroke: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      normalizedRadius: this.radius - this.stroke * 2,
      circumference: (this.radius - this.stroke * 2) * 2 * Math.PI
    }
  },
  computed: {
    strokeDashoffset() {
      return this.circumference - (this.progress / 100) * this.circumference
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  circle {
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
    stroke-linecap: round;
  }

  .slot {
    position: absolute;
  }
}
</style>
